<template>
	<div>
		<div class="frame" ref="room"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AdminLiveClassRoom',

	props: ['room', 'title'],

	data() {
		return {
			api: null,
			domain: '8x8.vc',
			height: '75%',
			options: {
				parentNode: document.getElementsByClassName('frame'),
				roomName: `vpaas-magic-cookie-6afe6fa648974f05a26593b85ed358c3/${this.room}`,
				// onLoad: this.function(),
				userInfo: {
					email: '',
					displayName: '',
				},
				configOverwite: {
					disableDeepLinking: true,
					prejoinPageEnabled: false,
					// startVideoMuted: 1
				},
				interfaceConfigOverwrite: {
					SHOW_CHROME_EXTENSION_BANNER: false,
					DISPLAY_WELCOME_PAGE_CONTENT: false,
					LANG_DETECTION: true,
					CLOSE_PAGE_GUEST_HINT: false,
					// MOBILE_APP_PROMO: true,
					// SHOW_JITSI_WATERMARK: false,
					// SHOW_WATERMARK_FOR_GUESTS: false,
					// SHOW_BRAND_WATERMARK: false,
					TOOLBAR_BUTTONS: [
						'microphone',
						'camera',
						'hangup',
						'closedcaptions',
						'desktop',
						'fullscreen',
						'fodeviceselection',
						'profile',
						'chat',
						'recording',
						'livestreaming',
						'etherpad',
						'sharedvideo',
						'settings',
						'raisehand',
						'videoquality',
						'filmstrip',
						'feedback',
						'stats',
						'tileview',
						'download',
						'mute-everyone',

						// 'invite', 'help', 'shortcuts', 'e2ee', 'security'
					],
				},
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			name_store: 'common/full_name',
			email_store: 'common/email',
			// clients: 'params/clients',
			// id_user_client_selected: 'common/id_user_client_selected',
		}),
	},

	methods: {
		initialConfig() {
			this.setUserInfo()
			this.addCustomFunctions()
		},

		setUserInfo() {
			this.api.executeCommand('email', this.email_store)
			this.api.executeCommand('displayName', this.name_store)
			this.api.executeCommand('subject', this.title)
		},

		addCustomFunctions() {
			this.api.on('participantJoined', this.newParticipant)

			this.api.on('readyToClose', this.endMeeting)
		},

		newParticipant({ displayName }) {
			this.$q.notify({
				message: `${displayName} ${this.$t('joined_the_class')}`,
				type: 'positive',
				icon: 'fas fa-user-plus',
				position: 'left',
			})
		},

		endMeeting() {
			setTimeout(() => {
				this.api.executeCommand('hangup')
				this.api.dispose()
			}, 100)
			setTimeout(() => {
				this.$emit('hideModalClassRoom')
			}, 150)
		},
	},

	beforeDestroy() {
		this.api ? this.api.dispose() : undefined
	},

	async mounted() {
		await this.jitsi()
		this.options.parentNode = this.$refs.room
		this.api = new JitsiMeetExternalAPI(this.domain, this.options)

		// setTimeout(() => {
		//     const iframe = this.$refs.room.querySelector("iframe")
		//     // console.log(iframe.contentWindow.document.querySelectorAll("button.deep-linking-mobile__button")[2])

		//     const buttons = document.querySelectorAll("button.deep-linking-mobile__button")
		//     const redirectButton = buttons[2]
		//     if (buttons) {
		//         console.log('True: ',
		//         buttons)
		//         iframe.contentWindow.document.querySelectorAll("button.deep-linking-mobile__button")[2].click()
		//     }
		//     else {
		//         console.log('No link')
		//         console.log(redirectButton)
		//     }
		// }, 6000)

		this.initialConfig()
	},
}
</script>

<style lang="stylus" scoped>

.frame
    height 95vh
    & iframe
        width 100%
        height 70vh
</style>
